export var ThemeHeaderLayout;
(function (ThemeHeaderLayout) {
    ThemeHeaderLayout["Cobranded"] = "cobranded";
    ThemeHeaderLayout["SingleLogo"] = "singleLogo";
})(ThemeHeaderLayout || (ThemeHeaderLayout = {}));
export var ThemeHeaderCopy;
(function (ThemeHeaderCopy) {
    ThemeHeaderCopy["Standard"] = "standard";
    ThemeHeaderCopy["SLR"] = "slr";
    ThemeHeaderCopy["ALR"] = "alr";
})(ThemeHeaderCopy || (ThemeHeaderCopy = {}));
//# sourceMappingURL=themeHeader.js.map